export default function getFileStyleByExtension(filename) {
  if (!filename) return { icon: "fa-file", color: "text-gray-500" };

  const ext = filename.split('.').pop().toLowerCase();

  switch (ext) {
    case 'jpg':
    case 'jpeg':
    case 'png':
    case 'gif':
    case 'bmp':
    case 'svg':
      return { icon: 'fa-file-image', color: 'text-blue-500' };

    case 'mp4':
    case 'mov':
    case 'avi':
    case 'wmv':
    case 'mkv':
      return { icon: 'fa-file-video', color: 'text-purple-500' };

    case 'mp3':
    case 'wav':
    case 'ogg':
      return { icon: 'fa-file-audio', color: 'text-pink-500' };

    case 'pdf':
      return { icon: 'fa-file-pdf', color: 'text-red-500' };

    case 'doc':
    case 'docx':
      return { icon: 'fa-file-word', color: 'text-blue-700' };

    case 'xls':
    case 'xlsx':
      return { icon: 'fa-file-excel', color: 'text-green-600' };

    case 'ppt':
    case 'pptx':
      return { icon: 'fa-file-powerpoint', color: 'text-orange-500' };

    case 'zip':
    case 'rar':
    case '7z':
      return { icon: 'fa-file-archive', color: 'text-yellow-500' };

    case 'txt':
    case 'md':
    case 'csv':
      return { icon: 'fa-file-alt', color: 'text-gray-600' };

    case 'html':
    case 'js':
    case 'css':
    case 'ts':
    case 'json':
      return { icon: 'fa-file-code', color: 'text-indigo-500' };

    default:
      return { icon: 'fa-file', color: 'text-gray-500' };
  }
}